import PromotionsService from '../../../modules/promotions/promotionsService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'PROMOTIONS_FORM'

const promotionsFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: promotionsFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await PromotionsService.find(id)
      }

      dispatch({
        type: promotionsFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: promotionsFormActions.INIT_ERROR,
      })

      dispatch(push('/promotions'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: promotionsFormActions.CREATE_STARTED,
      })

      await PromotionsService.create(values)

      dispatch({
        type: promotionsFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.promotions.create.success'),
      )

      dispatch(push('/promotions'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: promotionsFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: promotionsFormActions.UPDATE_STARTED,
      })

      await PromotionsService.update(id, values)

      dispatch({
        type: promotionsFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.promotions.update.success'),
      )

      dispatch(push('/promotions'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: promotionsFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default promotionsFormActions
